<template>
  <div>
    <el-drawer
      v-if="visible"
      :visible="visible"
      :title="$l('drawer_title_setNc') || '订单产品NC赋码'"
      direction="rtl"
      :size="1200"
      :close-on-press-escape="false"
      @close="close()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :noticeOrderCode="noticeOrderCode"
          @close="close()"
          @reload="$emit('reload')"
        />
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    noticeOrderCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 32px;
}
</style>
